import { render, staticRenderFns } from "./StakingHistory.vue?vue&type=template&id=3df3ff03&scoped=true&"
import script from "./StakingHistory.vue?vue&type=script&lang=js&"
export * from "./StakingHistory.vue?vue&type=script&lang=js&"
import style0 from "./StakingHistory.vue?vue&type=style&index=0&id=3df3ff03&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df3ff03",
  null
  
)

export default component.exports